import { useRecoilState, useRecoilValue } from "recoil";
import { useConfig } from "./config";
import selectionsStore from "src/stores/selections";
import mainStore from "src/stores/main";
import { IFreeBet } from "src/constants/interfaces/bet";
import { useCallback, useEffect, useState, useMemo } from "react";
import { checkFreeBets } from "src/services/freeBets";

export const useFreeBets = () => {
  const { hasFreeBets } = useConfig();
  const { selections } = useRecoilValue(selectionsStore);
  const [loading, setLoading] = useState(false);
  const [{ betType, freeBets, isFreeBetEnabled }, setMainState] = useRecoilState(mainStore);

  const eventIds = useMemo(() => selections.map(item => item.event.id).join(','), [selections]);
  
  useEffect(() => {
    if (hasFreeBets) {
      (async () => {
        if (isFreeBetEnabled) {
          setLoading(true);
          await checkFreeBets();
          setLoading(false);
        }
      })();
    } else setMainState((oldMainState) => ({ ...oldMainState, isFreeBetEnabled: false, freeBets: [] }));
  }, [betType, hasFreeBets, eventIds, isFreeBetEnabled]);

  useEffect(() => {
    return () => setMainState((oldMainState) => ({
      ...oldMainState,
      stake: '',
      freeBets: oldMainState.freeBets.map((freeBet) => ({ ...freeBet, selected: false })),
    }));
  }, []);

  const toggleFreeBet = useCallback((selected: IFreeBet) => (
    setMainState((oldMainState) => {
      const newFreeBets = oldMainState.freeBets.map((freeBet) => ({
        ...freeBet,
        selected: freeBet.details.id === selected.details.id,
      }));

      return { ...oldMainState, freeBets: newFreeBets, stake: `${selected.details.amount}` }
    })
  ), []);

  return [freeBets, toggleFreeBet, loading] as const;
};